import { featured } from "@/mocks/evidence";
import Reveal from "./Reveal";
import { SectionHeading, StatusBadge } from "./Ui";

export default function Featured() {
  return (
    <section id="latest" className="bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Latest · 最新实锤"
          title="最新归档 · 大图直达"
          desc="按更新时间倒序，优先呈现材料最完整、可直接判读的拆解条目。石锤、实锤、存疑分档标注，便于快速定位。"
          action={
            <a
              href="#archive"
              className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-700 hover:text-primary-800"
            >
              查看全部归档
              <i className="ri-arrow-right-line flex h-4 w-4 items-center justify-center text-sm" />
            </a>
          }
        />

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {featured.map((f, idx) => (
            <Reveal key={f.id} delay={idx * 90}>
              <article className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
                <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={f.image}
                    alt={f.title}
                    title={`${f.kicker} ${f.title}`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                  />
                  <div className="absolute inset-x-0 top-0 flex items-center justify-between p-3 md:p-4">
                    <span className="rounded bg-background-50/90 px-2 py-1 text-[11px] font-semibold text-foreground-800 backdrop-blur">
                      {f.kicker}
                    </span>
                    <StatusBadge status={f.status} />
                  </div>
                </div>
                <div className="flex flex-1 flex-col p-4 md:p-5">
                  <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                    <a href="#library" className="hover:text-primary-700">
                      {f.title}
                    </a>
                  </h3>
                  <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {f.desc}
                  </p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-calendar-line flex h-4 w-4 items-center justify-center text-sm" />
                      {f.date}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-file-list-line flex h-4 w-4 items-center justify-center text-sm" />
                      {f.meta}
                    </span>
                    <span className="inline-flex items-center gap-1 font-semibold text-primary-700">
                      拆解详情
                      <i className="ri-arrow-right-up-line flex h-4 w-4 items-center justify-center text-sm" />
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}